import React from 'react';
import { Check, Crown, X } from 'lucide-react';
export function Upsell() {
  const rows = [{
    situation: 'Alumna que pare',
    without: 'Perdés la alumna',
    with: 'Seguís 6 meses más'
  }, {
    situation: 'Cesárea + dudas',
    without: 'No sabés qué dar',
    with: 'Protocolo exacto'
  }, {
    situation: 'Diástasis residual',
    without: 'No podés avanzar',
    with: 'Ficha por grado'
  }, {
    situation: 'Incontinencia',
    without: 'Le decís "esperá"',
    with: 'Test + derivación'
  }, {
    situation: 'Ingresos totales',
    without: '9 meses/alumna',
    with: '15-18 meses/alumna'
  }];
  return <section className="py-16 md:py-24 px-4 bg-slate-50 border-y border-slate-200" data-id="element-435">
      <div className="max-w-5xl mx-auto" data-id="element-436">
        <div className="text-center mb-10 md:mb-14" data-id="element-437">
          <p className="text-secondary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-438">
            <Crown className="w-4 h-4" data-id="element-439" /> Upgrade premium
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto text-slate-900" data-id="element-440">
            ¿Qué agrega el{' '}
            <span className="text-secondary" data-id="element-441">
              Sistema Completo + Postparto?
            </span>
          </h2>
        </div>

        <div className="bg-white border border-secondary/30 rounded-3xl p-3 sm:p-6 md:p-10 shadow-[0_10px_40px_rgba(124,58,237,0.08)] mb-8" data-id="element-442">
          <div data-id="element-443">
            <div className="grid grid-cols-3 gap-1.5 sm:gap-4 mb-4 pb-4 border-b border-slate-200 text-[10px] sm:text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-444">
              <div data-id="element-445">Situación</div>
              <div className="text-red-500 flex items-center gap-1" data-id="element-446">
                <X className="w-3 h-3 sm:w-4 sm:h-4 shrink-0" data-id="element-447" /> Sin Postparto
              </div>
              <div className="text-secondary flex items-center gap-1" data-id="element-448">
                <Check className="w-3 h-3 sm:w-4 sm:h-4 shrink-0" data-id="element-449" /> Con
                Postparto
              </div>
            </div>

            <div className="space-y-4" data-id="element-450">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-1.5 sm:gap-4 items-center py-3 border-b border-slate-100 last:border-0" data-id="element-451">
                  <div className="text-slate-900 font-bold text-[11px] sm:text-sm md:text-base leading-tight" data-id="element-452">
                    {row.situation}
                  </div>
                  <div className="text-slate-500 text-[11px] sm:text-sm md:text-base leading-tight" data-id="element-453">
                    {row.without}
                  </div>
                  <div className="text-secondary font-bold text-[11px] sm:text-sm md:text-base bg-secondary/10 px-1.5 py-1.5 sm:px-3 sm:py-2 rounded-lg leading-tight" data-id="element-454">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <p className="text-center text-base md:text-xl text-slate-700 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-455">
          Si además de resolver tus clases querés{' '}
          <span className="text-secondary font-bold" data-id="element-456">
            acompañar a tu alumna en su recuperación,
          </span>{' '}
          esta es tu opción.
        </p>
      </div>
    </section>;
}